const DEVICE_MODE = 'DEVICE_MODE';
const DEVICE_MODE_GET = 'DEVICE_MODE_GET';
const DEVICE_INNER_SIZE = 'DEVICE_INNER_SIZE';

const handleDeviceMode = (mode) => ({
    type: DEVICE_MODE,
    payload: {
        mode
    }
});

const handleGetDeviceMode = () => ({
    type: DEVICE_MODE_GET,
});

const handleDeviceSize = (width, height) => ({
    type: DEVICE_INNER_SIZE,
    payload: {
        width, height
    }
});


export {
    DEVICE_MODE,
    DEVICE_MODE_GET,
    DEVICE_INNER_SIZE,
    handleDeviceMode,
    handleGetDeviceMode,
    handleDeviceSize
}
